module.exports = __webpack_public_path__ + "static/media/plexusStaticOpen.963f5118.jpg";